export default {
  product: {
    new: 'Novo elemento do catálogo',
    data: 'Introduza os dados do novo artigo do catálogo',
    add: 'Incluir no catálogo',
    addAndSelect: 'Incluir no catálogo e selecionar'
  },
  productsTable: {
    modifyAndUpdate: 'Modifique os dados do artigo e clique em "Atualizar artigo" para manter as alterações realizadas',
    saveNew: 'Guardar como novo elemento',
    create: 'Criar',
    update: 'Atualizar',
    createAndSelect: 'Criar e selecionar',
    updateAndSelect: 'Atualizar e selecionar',
    undo: 'Desfazer alterações',
    select: 'Selecionar',
    noResults: 'Nenhum resultado encontrado',
    vendorCode: 'Cód. Vendedor',
    description: 'Descrição',
    price: 'Preço'
  },
  searchCatalog: {
    catalog: 'Catálogo',
    products: 'Produtos/Serviços',
    search: 'Buscar no catálogo',
    showing: 'Mostrando',
    vendorCode: 'Código vendedor',
    description: 'Descrição',
    price: 'Preço',
    more: 'Ver mais',
    newElement: 'Novo elemento',
    addSelected: 'Adicionar selecionado',
    deleteTitle: 'Excluir produtos selecionados',
    deleteConfirm: 'Tem certeza de que deseja excluir os produtos selecionados?'
  },
  catalogView: {
    deleteTitle: 'Lista de produtos selecionados para excluir',
    success: 'Os produtos foram excluídos com sucesso.'
  }
}